import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getOficios from '../../../graphql/querys/tramites/getOficios.graphql';
import deleteOficio from '../../../graphql/mutations/tramites/deleteOficio.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import getOficiosPorRangoConFiltros from '../../../graphql/querys/tramites/getOficiosPorRangoConFiltros.graphql';
import getCantidadOficiosConFiltros from '../../../graphql/querys/tramites/getCantidadOficiosConFiltros.graphql';
import getOficioPorId from '../../../graphql/querys/tramites/getOficioPorId.graphql';

import TablaOficios from './TablaOficios';

import { imprimir } from '../../common/funciones/imprimir';
import { errorService } from '../../../graphql/utils/utils';
import ModalMandarEmail from './email/ModalMandarEmail';
import ModalVisorEmail from '../../common/ModalVisorEmail';
import { verPdf } from '../../common/funciones/verPdf';

const confirm = Modal.confirm;
@compose(
  graphql(getUsuario),
  graphql(deleteOficio, {
    name: 'deleteOficio',
    options: {
      refetchQueries: [{ query: getOficios }],
    },
  })
)
class ListarOficios extends React.Component {
  constructor(props) {
    super(props);

    let fechaIni = moment()
      .subtract(7, 'd')
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toDate();

    let fechaFin = moment()
      .endOf('day')
      .toDate();

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
      datosImpresion: {},
      filtroNombre: null,
      filtroApellido: null,
      filtroDocumento: null,
      fechaInicio: fechaIni,
      fechaFin: fechaFin,
      pagina: 1,
      cantidadPorPagina: 10,
      cantidadTotal: 0,
      loadingTabla: false,
      visibleModalMandarEmail: false,
      visibleModalVisorEmail: false,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    this.getOficiosPorRangoConFiltros();
  }

  getOficiosPorRangoConFiltros = () => {
    // console.log('VOY A LLAMAR:');
    this.setState({ loadingTabla: true });
    this.props.client
      .query({
        query: getCantidadOficiosConFiltros,
        variables: {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
        },
      })
      .then(resp => {
        // console.log('RESPONDE QUE : ', resp);
        if (
          resp.data.getCantidadOficiosConFiltros ||
          resp.data.getCantidadOficiosConFiltros == 0
        ) {
          this.setState({
            cantidadTotal: resp.data.getCantidadOficiosConFiltros,
          });

          this.props.client
            .query({
              query: getOficiosPorRangoConFiltros,
              variables: {
                fechaInicial: this.state.fechaInicio,
                fechaFinal: this.state.fechaFin,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              },
              fetchPolicy: 'network-only',
            })
            .then(res => {
              // console.log('ME RETORNA: ', res);
              this.setState(
                {
                  ...this.state,
                  listaTotal: res.data.getOficiosPorRangoConFiltros,
                  listaOriginal: res.data.getOficiosPorRangoConFiltros,
                  primeraCarga: false,
                  loadingTabla: false,
                },
                function() {
                  this.ordenarLista(
                    this.state.pagina,
                    this.state.cantidadPorPagina
                  );
                }
              );
            })
            .catch(err => {
              console.log('ERROR EN EL DOCUMENTOS INDEPENDIENTES POR RANGO: ');
              console.log(err);
              errorService(err, {
                fechaInicial: this.state.fechaInicio,
                fechaFinal: this.state.fechaFin,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              });
              Modal.error({
                title: 'Error en la busqueda de Documentos Independientes',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        } else {
          console.log('NO RESPONDIO BIEN');
        }
      })
      .catch(err => {
        console.log(
          'ERROR A LA HORA DE OBTENER LA CANTIDAD TOTAL DE DOCUMENTOS'
        );
        console.log('EL ERROR ES: ', err);
        errorService(err, {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
        });
      });
  };

  onDelete(id) {
    //TODO: Hacer el onDelete.
    // console.log("Se desea eliminar la declaracion jurada con id ", id);

    // console.log("USUARIOOOOOOO: ");
    // console.log(this.props.usuario);

    let { usuario } = this.props;

    if (usuario.rol == 'SUPERVISOR' || usuario.rol == 'FUNCIONARIO') {
      let yo = this;
      confirm({
        title: 'Realmente quiere eliminar este Documento Independiente?',
        content: 'Esta accion no podrá deshacerse',
        onOk() {
          yo.props
            .deleteOficio({
              variables: { _id: id },
            })
            .then(res => {
              // console.log("La respuesta del delete fue....");
              // console.log(res);

              let id = res.data.deleteOficio;

              if (id) {
                yo.eliminarElementoYActualizarLista(id);

                notification.warning({
                  message: 'Documento Independiente eliminado',
                  description:
                    'Se ha eliminado el Documento Independiente exitosamente',
                });
              }
            })
            .catch(err => {
              console.log(
                'Existio un error a la hora de eliminar el Documento Independiente'
              );
              console.log(err);
              errorService(err, {
                _id: id,
              });
              Modal.error({
                title: 'Error en la eliminacion del Documento Independiente',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      Modal.error({
        title:
          'Usted no tiene los permisos necesarios para realizar esta operación',
        content:
          'Para poder realizar esta función, debe tener mas permisos en su cuenta de los que tiene ahora mismo. Por favor, en caso de ser necesario, comuníquese con mesa de ayuda del departamento de informática.',
      });
    }
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];
    let total = this.state.cantidadTotal;

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
        cantidadTotal: total - 1,
      },
      function() {
        this.ordenarLista(this.state.pagina, this.state.cantidadPorPagina);
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    // console.log('CAMBIE:! ', date);
    this.setState(
      {
        ...this.state,
        fechaInicio: date[0]
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate(),
        fechaFin: date[1]
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toDate(),
      },
      () => {
        this.getOficiosPorRangoConFiltros();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    // console.log('Listaaaa');
    // console.log(this.state.listaTotal);
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        oficio => {
          // return declaracion.declarante.apellido.toUpperCase();
          return oficio.fechaCreacion;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaOrdenada,
    });
  };

  onImprimir = registro => {
    imprimir(registro.textoNota);
  };

  onDescargar = registro => {
    this.props.client
      .query({
        query: getOficioPorId,
        variables: { _id: registro._id },
      })
      .then(res => {
        let oficio = res.data.getOficioPorId;
        if (oficio && oficio.pdfBase64) {
          verPdf(oficio.pdfBase64, `Oficio_Num_${oficio.numero}_${oficio._id}`);
        }
      })
      .catch(err => {
        console.log('Error en la obtencion del oficio');
        console.log(err);

        errorService(err, {
          _id: registro._id,
          registro,
        });

        Modal.error({
          title: 'Error en la obtencion del oficio desde el servidor',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        this.getOficiosPorRangoConFiltros();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  mostrarModalMandarEmail = idOficio => {
    this.setState({
      visibleModalMandarEmail: true,
      idOficio: idOficio,
    });
  };

  ocultarModalMandarEmail = () => {
    this.setState({
      visibleModalMandarEmail: false,
      idOficio: null,
    });
  };

  mostrarModalVisorEmail = idOficio => {
    this.setState({
      visibleModalVisorEmail: true,
      idOficio: idOficio,
    });
  };

  ocultarModalVisorEmail = () => {
    this.setState({
      visibleModalVisorEmail: false,
      idOficio: null,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div>
        <TablaOficios
          oficios={this.state.lista}
          history={this.props.history}
          onDelete={this.onDelete}
          onChange={this.onChange}
          fechaInicio={this.state.fechaInicio}
          fechaFin={this.state.fechaFin}
          pagina={this.state.pagina}
          imprimir={this.onImprimir}
          descargar={this.onDescargar}
          cambiarPagina={this.cambiarPagina}
          cambiarTamañoPagina={this.cambiarTamañoPagina}
          total={this.state.cantidadTotal}
          cantidadPorPagina={this.state.cantidadPorPagina}
          loadingTabla={this.state.loadingTabla}
          mostrarModalMandarEmail={this.mostrarModalMandarEmail}
          mostrarModalVisorEmail={this.mostrarModalVisorEmail}
        />

        <ModalMandarEmail
          visibleModalMandarEmail={this.state.visibleModalMandarEmail}
          ocultarModalMandarEmail={this.ocultarModalMandarEmail}
          idOficio={this.state.idOficio}
        />

        <ModalVisorEmail
          id={this.state.idOficio}
          visibleModalLogsEmail={this.state.visibleModalVisorEmail}
          ocultarModalLogsEmail={this.ocultarModalVisorEmail}
        />
      </div>
    );
  }
}

export default withApollo(ListarOficios);
